import useTranslation from 'next-translate/useTranslation'
import { memo } from 'react'

import BenefitList from '@/atoms/BenefitList'
import { addProductToCart } from '@/store/slices/cart'
import Product, { ProductContestEntry } from '@/ts/Product'

import AddToCartButton from './includes/AddToCartButton'
import Header from './includes/Header'

function ShoppingCard({ product, entry }: ShoppingCardProps) {
  const { t } = useTranslation('products')

  const onClick = () =>
    addProductToCart({
      ...product,
      price: entry.price,
      contest_entry_id: entry.id,
    })

  return (
    <article className="flex justify-center flex-none px-6 py-8 border-2 shadow-xl xl:px-12 md:py-14 border-sbtviolet-100 rounded-xl">
      <div className="w-full max-w-md">
        <Header entry={entry} />
        <h2 className="mt-6 font-medium">{t('contest_guarantees')}</h2>
        <BenefitList
          className="mt-3 mb-6"
          benefits={entry.benefits}
          color="purple"
        />
        {product?.status === 'active' && (
          <AddToCartButton onClick={() => onClick()} />
        )}
      </div>
    </article>
  )
}

interface ShoppingCardProps {
  product: Product
  entry: ProductContestEntry
}

export default memo(ShoppingCard)
